import { ClipboardList } from 'lucide-react';

import { formatarData } from '@/nucleo/formato/datas';
import { EmptyState } from '@/ui/EmptyState';
import { Spinner } from '@/ui/Spinner';
import { StatusBadge, type StatusVariant } from '@/ui/StatusBadge';
import { Card, CardContent } from '@/ui/base/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/ui/base/table';

import { useOrdensDeServicoDoCredenciado, type OrdemDeServicoDoCredenciado } from './detalheDados';

interface AbaOrdensDeServicoProps {
  credenciadoId: string;
}

const SELO_DO_STATUS_DA_OS: Record<OrdemDeServicoDoCredenciado['status'], StatusVariant> = {
  EM_EXECUCAO: 'em_execucao',
  CONCLUIDA: 'concluida',
  SUSPENSA: 'suspenso',
  CANCELADA: 'cancelado',
};

function periodo(inicio: string | null, fim: string | null): string {
  if (!inicio && !fim) return '—';
  return `${formatarData(inicio)} → ${formatarData(fim)}`;
}

/**
 * Aba "Ordens de Serviço". SEM CLIQUE NA LINHA DE PROPOSITO: o protótipo levava a
 * `/ordens/:id`, rota que nao existe aqui — ver o mesmo raciocinio em `AbaTermos`.
 */
export function AbaOrdensDeServico({ credenciadoId }: AbaOrdensDeServicoProps) {
  const { data: ordens, isLoading } = useOrdensDeServicoDoCredenciado(credenciadoId);

  return (
    <Card>
      <CardContent className="p-6">
        {isLoading ? (
          <Spinner size="sm" />
        ) : !ordens || ordens.length === 0 ? (
          <EmptyState
            icon={ClipboardList}
            title="Nenhuma OS vinculada"
            description="As ordens de serviço serão exibidas aqui quando emitidas."
          />
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Número</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Termo (SEI)</TableHead>
                <TableHead>Emissão</TableHead>
                <TableHead>Período</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {ordens.map((os) => (
                <TableRow key={os.id}>
                  <TableCell className="font-mono font-medium">
                    OS-{String(os.numero).padStart(4, '0')}
                  </TableCell>
                  <TableCell>
                    <StatusBadge status={SELO_DO_STATUS_DA_OS[os.status]} label={os.status} />
                  </TableCell>
                  <TableCell className="font-mono">{os.numero_sei_termo || '—'}</TableCell>
                  <TableCell>{formatarData(os.data_emissao)}</TableCell>
                  <TableCell>{periodo(os.data_inicio, os.data_fim)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
